import useLazyLoad from "app/components/hooks/useLazyLoad";
import usePageProps from "app/components/hooks/usePageProps";
import Icon from "app/components/Icon";
import Layout from "app/components/Layouts/Layout"
import { MODALS, ModalsContext } from "app/components/Layouts/Modals";
import { TaskType } from "app/components/Types/TaskType";
import { UserType } from "app/components/Types/UserType";
import Form from "app/fragments/Forms/Form";
import OrderBy from "app/fragments/Forms/OrderBy";
import Radio from "app/fragments/Forms/Radio";
import IconText from "app/fragments/IconText";
import { LineButton } from "app/fragments/LineButton";
import { useContext, useState } from "react";
import { EditMenuContextProvider, TaskCard, TaskRow } from "../../fragments/TaskCard";


interface Props {

}


function Index(props: Props) {

    const [tasks, button, meta, form, setTask] = useLazyLoad<TaskType>('tasks', [], {order_by: 'latest', order: 'desc' });
    let { open } = useContext(ModalsContext)
    const { user } = usePageProps<{ user: UserType }>();

    const [showFilters, setShowFilters] = useState(false)
    const [view, setView] = useState(false);

    return (
        <Layout className="text-white" heading="My Tasks">
            <div className="flex justify-between mt-40px mob:flex-col">
                <h2 className="text-24 font-bold mob:order-2">Hi {user.name},</h2>
                <div className="flex gap-16px items-center mob:mb-16px mob: justify-between">

                    <a className={`cursor-pointer ${!view ? 'bg-gray-1C1C1C hover:bg-gray-1C1C1C/70' : 'hover:bg-gray-1C1C1C/60'} rounded-full w-47px h-47px flex items-center justify-center `} onClick={() => setView(false)}><Icon name="grid" /></a>
                    <div className="nMob:hidden w-47px" />
                    <a className={`cursor-pointer mob:hidden  ${view ? 'bg-gray-1C1C1C hover:bg-gray-1C1C1C/70' : 'hover:bg-gray-1C1C1C/60'} rounded-full w-47px h-47px flex items-center justify-center `} onClick={() => setView(true)}><Icon name="rows" /></a>
                    <a className="cursor-pointer" onClick={() => open(MODALS.NEWTASK)}><IconText className="bg-green-539648 hover:bg-green-539648/70 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Add Task" /></a>
                    <a className={`cursor-pointer ${showFilters ? 'bg-gray-1C1C1C hover:bg-gray-1C1C1C/70' : 'hover:bg-gray-1C1C1C/60'} rounded-full w-47px h-47px flex items-center justify-center `} onClick={() => setShowFilters(f => !f)}><Icon name="filters" /></a>
                </div>
            </div>
            <div className="mt-16px text-16 text-[#CCCCCC]">
                seems like you're a firefighter today, <span className='font-bold'>go extinguish those pesky fires 🔥</span>!
            </div>
            {
                showFilters &&
                <div className="p-20px py-10px bg-gray-1C1C1C rounded mt-20px -mb-30px">
                    <Form form={form}>
                        <div className="flex items-center flex-wrap mob:text-14">
                            <div className="mr-15px my-12px 1280px:w-full mob:flex mob:items-center mob:mr-0"><span className="mob:flex-shrink-0 mob:mr-14px">Order by:</span> <hr className="border-C4C4C4 border-dashed border-t nMob:hidden w-full" /></div>
                           
                            <div className={`flex mr-15px mt-12px items-center `}>
                                <Radio className="mr-15px" name="order_by" value="latest" label="Activity" />
                            </div>
                            <div className={`flex mr-15px mt-12px items-center `}>
                                {/* <Radio className="mr-15px" name="order_by" value="id" label="ID" /> */}
                                <OrderBy className="mr-15px" name="order_by" value="id" label="ID" />
                            </div>
                            <div className={`flex mr-15px mt-12px items-center `}>
                                <OrderBy className="mr-15px" name="order_by" value="name" label="Name" />
                            </div>
                            <div className={`flex mr-15px mt-12px items-center `}>
                                <OrderBy className="mr-15px" name="order_by" value="deadline" label="Deadline" />
                            </div>
                            <div className={`flex mr-15px mt-12px items-center `}>
                                <OrderBy className="mr-15px" name="order_by" value="estimate" label="Estimate" />
                            </div>
                        </div>
                    </Form>
                </div>
            }
            <div className={`grid ${!view ? 'grid-cols-3' : 'grid-cols-1'} gap-30px py-60px mob:grid-cols-1`}>
                {/* <div onClick={(e) => { e.preventDefault(); open(MODALS.NEWTASK) }} className="fixed top-1/2 cursor-pointer right-50px w-50px h-50px bg-blue-700 rounded-full flex items-center justify-center">
                    <Icon className={"transform rotate-45 w-16px"} name="cross" />
                </div> */}

                {
                    tasks.map(t =>
                       !view 
                        ? <TaskCard t={t} />
                        : <TaskRow t={t} />
                    )
                }
            </div>
            {button && <LineButton {...button} text={`Show more (${meta.next})`} href={"#"} showing={{ max: meta.total, current: meta.to }} />}
            {/* {
                meta &&
                <div className="flex justify-center my-20px">
                    <div className="text-white text-16">Zobrazuji {meta.to} z {meta.total}</div>
                </div>
            } */}
        </Layout>
    )
}

export default Index
